export const HorizontalRule = 'hr';
//# sourceMappingURL=index.js.map